import React from 'react';
import { XCircle, TrendingDown, Clock, Smartphone } from 'lucide-react';
export function Problem() {
  return <section className="bg-navy-900 px-4 py-16 sm:px-6 lg:px-8 lg:py-24" data-id="element-181">
      <div className="mx-auto max-w-4xl" data-id="element-182">
        <div className="mb-16 text-center" data-id="element-183">
          <h2 className="mb-6 text-4xl sm:text-5xl font-bebas text-white" data-id="element-184">
            El Castigo Diario del{' '}
            <span className="text-red-400" data-id="element-185">Mal Crédito</span>
          </h2>
          <p className="text-xl text-slate-300 max-w-2xl mx-auto" data-id="element-186">
            Vivir con mal crédito en USA no es solo un número. Es pagar el doble
            de intereses en tu auto. Es que te nieguen el apartamento que
            necesitas. Es sentir que el sueño de tener casa propia no es para
            ti.
          </p>
        </div>

        <div className="mb-16 rounded-2xl bg-navy-800 p-8 border border-slate-700/50 shadow-xl" data-id="element-187">
          <h3 className="mb-4 text-2xl font-bebas text-gold-400" data-id="element-188">
            Y lo más injusto
          </h3>
          <p className="text-lg text-slate-300" data-id="element-189">
            Las agencias de reparación te cobran $99 al mes para enviarte una
            carta. Una sola carta. Mientras tu vida sigue igual.
          </p>
        </div>

        <h3 className="mb-8 text-center text-3xl font-bebas text-white" data-id="element-190">
          Por qué lo que has intentado{' '}
          <span className="text-red-400" data-id="element-191">NO FUNCIONÓ</span>
        </h3>

        <div className="grid gap-6 sm:grid-cols-3" data-id="element-192">
          <div className="rounded-xl bg-navy-800 p-6 border border-slate-700/50 hover:border-red-500/30 transition-colors" data-id="element-193">
            <Smartphone className="mb-4 h-8 w-8 text-slate-400" data-id="element-194" />
            <h4 className="mb-2 text-xl font-bold text-white" data-id="element-195">
              Apps Gratuitas
            </h4>
            <p className="text-slate-400" data-id="element-196">
              Credit Karma te muestra el problema pero no tiene herramientas
              legales para resolverlo.
            </p>
          </div>

          <div className="rounded-xl bg-navy-800 p-6 border border-slate-700/50 hover:border-red-500/30 transition-colors" data-id="element-197">
            <Clock className="mb-4 h-8 w-8 text-slate-400" data-id="element-198" />
            <h4 className="mb-2 text-xl font-bold text-white" data-id="element-199">
              Ignorar las Deudas
            </h4>
            <p className="text-slate-400" data-id="element-200">
              No las borra — los burós venden tu información y los errores se
              multiplican.
            </p>
          </div>

          <div className="rounded-xl bg-navy-800 p-6 border border-slate-700/50 hover:border-red-500/30 transition-colors" data-id="element-201">
            <TrendingDown className="mb-4 h-8 w-8 text-slate-400" data-id="element-202" />
            <h4 className="mb-2 text-xl font-bold text-white" data-id="element-203">
              Pagar Sin Estrategia
            </h4>
            <p className="text-slate-400" data-id="element-204">
              Pagar deudas viejas sin estrategia puede bajar tu puntaje al
              reactivar cuentas dormidas.
            </p>
          </div>
        </div>
      </div>
    </section>;
}